import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function GivenNameField({
  value,
  error,
  setValue,
  setError,
  setChanged,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (/[#^$<>+%!`&*|{}?/\\:=@]/.test(newValue)) {
      setError('First name cannot contain #^$<>+%!`&*|{}?/\\:=@');
    } else if (newValue === '') {
      setError('First name cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='First Name'
          id='given_name'
          aria-describedby='first-name-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
        />
        {error ? (
          <FormHelperText id='first-name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='first-name-helper-text'>
            Enter your first (given) name.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
